import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { gbp } from "@/lib/stages";
import { Mgr } from "@/components/portal/crm/kit";

/**
 * NeedsAWord — the Hub's copy of the partner support card.
 *
 * It used to report that the 08:00 digests had gone out. True, but there is nothing a desk can do
 * with it. This names the one partner holding up the most money and puts their WhatsApp on it —
 * the same job the partner-facing card does, pointed the other way.
 *
 * Falls back to the digest line only when genuinely nobody needs chasing.
 */
export function NeedsAWord({ introducers = 0, desks = 0 }) {
  const [row, setRow] = useState(undefined);

  useEffect(() => {
    api.get("/hub/needs-a-word")
      .then((r) => setRow(r.data?.item || null))
      .catch(() => setRow(null));
  }, []);

  if (row === undefined) {
    return <Mgr label="This morning" who="Reading the book…" testId="hub-desk-morning" />;
  }

  if (!row) {
    return (
      <Mgr label="This morning" who="Nobody needs chasing"
           role={`Every desk is inside its turnaround and no case is waiting on an introducer. Briefing ${introducers} introducer${introducers === 1 ? "" : "s"} and ${desks} desk${desks === 1 ? "" : "s"} at 08:00 UK.`}
           live="Scheduler healthy" testId="hub-desk-morning">
        <Link className="btn btn-primary btn-block" to="/hub/messages">Open the inbox</Link>
      </Mgr>
    );
  }

  const first = row.greet || "";
  const text = `${first ? `Hi ${first} — ` : "Hi — "}${row.why}. Can we get it moving?\n\nConnexis`;

  return (
    <Mgr label="Worth a word today" who={row.name}
         role={`${row.why} · ${gbp(row.at_stake_gbp)} riding on it`}
         live={row.relationship} testId="hub-desk-morning">
      {row.company && (
        <div style={{ marginTop: -6, marginBottom: 3, fontSize: 11.5, fontWeight: 600,
          color: "rgba(255,255,255,.55)" }} data-testid="hub-needs-word-company">{row.company}</div>
      )}
      {row.whatsapp ? (
        <a className="btn btn-primary btn-block" target="_blank" rel="noreferrer"
           href={`https://wa.me/${row.whatsapp}?text=${encodeURIComponent(text)}`}
           data-testid="hub-needs-word-whatsapp">
          WhatsApp{first ? ` ${first}` : ""}
        </a>
      ) : (
        <a className="btn btn-primary btn-block" href={`mailto:${row.email}`}
           data-testid="hub-needs-word-email" title="No mobile on their record">
          Email{first ? ` ${first}` : ""} — no mobile on file
        </a>
      )}
      <Link className="btn btn-ghost btn-block" to={`/hub/leads/${row.lead_id}`}
            data-testid="hub-needs-word-case"
            style={{ background: "rgba(255,255,255,.07)", borderColor: "rgba(255,255,255,.18)", color: "#fff" }}>
        Open the case
      </Link>
    </Mgr>
  );
}
